// extracted by mini-css-extract-plugin
module.exports = {"tittel":"Lenkeliste_tittel__1qdmB","lenker":"Lenkeliste_lenker__vZqEf","lenke":"Lenkeliste_lenke__R5BL7","ulListe":"Lenkeliste_ulListe__hXU_e"};